import styled from 'styled-components'

export const Illustration = styled.img`
  display: block;
  max-width: 100%;
`
